import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/pipeline-by-owner/ranked";

export const fetchPipelineByOwnerRanked = createAsyncThunk(
  "pipelineByOwnerRanked/fetch",
  async (_, { getState }) => {
    const { filters } = getState().capture.dashboard;
    const { periodStart, periodEnd } = resolvePeriod(filters);
    const { offset, pageSize } = getState().capture.pipelineByOwnerRanked;

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd, offset, pageSize },
    });
    return data;
  },
);
